import { useCallback, useContext, useState } from 'react'
import FileInput from '../../../../importers/FileInput'
import Tooltip from '../../../../common/tooltip'
import Button from '../../../../common/Button'
import { postRequest } from '../../../../../services/base'
import { useParams } from 'react-router-dom'
import { downloadErrorLogs } from '../../../../../utils/common'
import { NavContext } from '../../../../../context/global_context'

const SalesCodeComplexityForm = (props) => {
  const { vehicle } = useParams()

  const [selectedFiles, setSelectedFiles] = useState([])
  const [response, setResponse] = useState({})
  const [showDetails, setShowDetails] = useState({})
  const [state, dispatch] = useContext(NavContext)

  const onChangeSalesCodeFile = (event) => {
    let tempSelectedFiles = [...selectedFiles]
    for (let index = 0; index < event.target.files.length; index++) {
      tempSelectedFiles.push(event.target.files[index])
    }
    setSelectedFiles(tempSelectedFiles)
  }

  const submitSalesCodeFiles = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Sales Code Complexity file processing in progress',
        showLoader: true,
      },
      notification: {},
    })
    let formData = new FormData()
    selectedFiles.map((value, index) => {
      formData.append('files', value)
    })
    let res = await postRequest(
      `/api/plugin/sales_code/upload/${vehicle}/`,
      formData
    )

    setResponse(res.data.details)
    props.getSalesCodeComplexityData('')
    setTimeout(() => {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File processed successfully!',
        },
      })
    }, 300)
  }

  const onClickDetails = (file_name, index) => {
    setShowDetails({ index: index, data: response[file_name] })
    if (response[file_name].error.length > 0) {
      downloadErrorLogs(response[file_name].error)
    } else {
      alert('Error logs not available')
    }
  }

  return (
    <>
      {Object.keys(response).length == 0 && (
        <div className="flex justify-end ">
          <FileInput
            labelTitle={'Select Sales Code Complexity Files'}
            fileFieldName={'sales_code_complexity'}
            fileFieldId={'sales-code-complexity'}
            onChange={(e) => {
              onChangeSalesCodeFile(e)
            }}
            multiple={true}
          />
        </div>
      )}
      {selectedFiles?.length > 0 && (
        <div className="font-light mt-3">
          <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
            <div className="flex w-1/12 items-center justify-center"></div>
            <div className="flex w-8/12 items-center">File Name</div>
            <div className="flex w-3/12 pl-6 items-center"></div>
          </div>
        </div>
      )}
      <div style={{ maxHeight: '300px', overflowY: 'scroll' }}>
        {selectedFiles.map((row, index) => {
          return (
            <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
              <div className="flex w-1/12 items-center justify-center">
                {index + 1}
              </div>
              <div className="flex w-7/12 items-center table_text">
                <Tooltip position={'top'} message={row.name}>
                  <div>{row.name}</div>
                </Tooltip>
              </div>
              {response[row.name]?.error?.length > 0 ? (
                <div
                  className="flex w-4/12 pl-6 items-center underline text-blue-500 cursor-pointer"
                  onClick={() => {
                    onClickDetails(row.name, index)
                  }}
                >
                  Download Error Logs
                </div>
              ) : (
                <div className="flex w-4/12 pl-6 items-center underline text-green-500 cursor-pointer">
                  Completed
                </div>
              )}
            </div>
          )
        })}
      </div>

      {selectedFiles?.length > 0 && Object.keys(response).length == 0 && (
        <div className="flex justify-end">
          <div className="w-1/3">
            <Button
              type="submit"
              className={`cursor-pointer btn my-4 w-full justify-end`}
              onClick={(e) => {
                submitSalesCodeFiles()
              }}
              value={'text'}
              text={'Save Complexity Files'}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default SalesCodeComplexityForm
